import AboutImage from "../../image/AboutImage.jpg";
import Card from "../../component/Card";
import data from "./data";
import "./about.css";


const About = () => {
  return (
    <section id="about">
      <div className="about_container">
        <div className="about__left">
          <div className="about__portrait">
            <img
              className="aboutImage"
              src={AboutImage}
              alt="About Image"
            />
          </div>
        </div>
        <div className="about__right">
          <h2>About Us</h2>
          <div className="about__cards">
            {data.map((item) => (
              <Card key={item.id} className="about__card">
                <span className="about__card-icon">
                  {item.icon}
                </span>
                <h5>{item.title}</h5>
                <small>{item.desc}</small>
              </Card>
            ))}
          </div>
          <p>
            Originally established in 2022 as a toll and
            private label manufacturer, General Paint
            started its automotive coating production in the
            late to become one of the fastest-growing
            producers of car paints and ancillaries for the
            refinish industry.
          </p>
          <p>
            With facilities and affiliate offices in Europe,
            the Middle East, and the USA, GPC currently
            distributes its products in more than 70+
            countries around the globe; it has a
            significantly more dominant position in the
            Middle Eastern and Gulf region where it is
            ranked as the refinish market leader in several
            countries. GenRock, GenVerde, and Gen2O, the
            systems sold by GPC, consist of a wide selection
            of products for automotive refinish coatings,
            that comply with international regulations.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
